<template>
<section id="highTerpeneResults">
  <section v-for="(thisSection,index) in value" :key="'terps' + index" data-autoslide="5000">
    <div
      class="sl-block"
      data-block-type="text"
      style="width: 100%; left: 29px; top: 84px; height: auto"
    >
      <div
        class="sl-block-content"
        data-placeholder-tag="h2"
        data-placeholder-text="Title Text"
        style="text-align: left; z-index: 10"
        dir="ui"
      >
        <h2 style="text-align: center; font-family: Poppins">Exceptional Terpenes</h2>
      </div>
    </div>

    <div
      class="sl-block theme--dark"
      data-block-type="table"
      style="
        height: auto;
        min-width: 120px;
        width: 100%;
        left: 29px;
        top: 175.5px;
        min-height: 550px;
        display: flex;
        justify-content: center;
        align-items: center;
      "
    >
      <terpene-stacked-bar v-model="value[index]" :canvasId="'terpStackedChart-' + index" />
    </div>
  </section>
  </section>
</template>

<script>

import TerpeneStackedBar from "./TerpeneStackedBar.vue";

export default {
  name: "",
  props: ["value"],
  components: { TerpeneStackedBar },
  beforeMount() {
   
  },
  mounted() {},
  data() {
    return {
      harvestSchedule: [],
      gifUrl: null,
      videoUrl: null,
    };
  },

  computed: {
   
  },
  watch: {
   
  },
  methods: {
   
  },
};
</script>
<style>
</style>

